var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.loadComplete)?_c('router-view',{staticClass:"view"}):_vm._e(),_c('Tooltip')],1)}
var staticRenderFns = []

export { render, staticRenderFns }